import { Dialog, DialogTitle, DialogContent, DialogActions, Alert } from '@mui/material';
import { GlobalButtonVariant } from '@/components/buttons/GlobalButton';
import { GlobalButton } from '@/components';

interface AmendmentConfirmModalProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  amendmentName: string;
  fromStatusName: string;
  toStatusName: string;
  reason: string;
  driverName?: string;
}

const AmendmentConfirmModal = ({
  open,
  onClose,
  onConfirm,
  amendmentName,
  fromStatusName,
  toStatusName,
  reason,
  driverName,
}: AmendmentConfirmModalProps) => {
  return (
    <Dialog 
      open={open} 
      onClose={onClose} 
      maxWidth='sm' 
      fullWidth
    >
      <DialogTitle sx={{ px: 4, pt: 3, pb: 2, fontSize: '1.5rem', fontWeight: 700, color: '#1e293b', letterSpacing: '-0.025em' }}>
        Confirmar enmienda
      </DialogTitle>
      <DialogContent dividers sx={{ px: 4, pt: 3, pb: 2 }}>
        <div className='text-slate-600 text-[15px] leading-relaxed flex flex-col gap-4'>
            <p>
              Estás a punto de aplicar la enmienda <strong className='text-slate-800 font-semibold'>{amendmentName}</strong>.
            </p>
            <ul className='list-disc pl-5 flex flex-col gap-3'>
              <li>
                El pedido pasará del estado <strong className='text-slate-800 font-semibold'>{fromStatusName}</strong> al estado <strong className='text-slate-800 font-semibold'>{toStatusName}</strong>.
              </li>
              {driverName && (
                <li>
                  Se asignará al conductor: <strong className='text-slate-800 font-semibold'>{driverName}</strong>.
                </li>
              )}
              <li className='pr-2'>
                Motivo:
                <div className='mt-2 p-3 bg-slate-50 text-slate-500 rounded-md border border-slate-100 italic text-[14px]'>
                  "{reason}"
                </div>
              </li>
            </ul>
            
            {driverName && (
              <Alert severity='warning' sx={{ mt: 3, borderRadius: 2 }}>
                Por favor, verificá que el conductor seleccionado sea el correcto para este pedido.
              </Alert>
            )}

            <p className='mt-4 text-[#ff7500] font-semibold text-[16px]'>
              ¿Estás seguro de que deseas continuar?
            </p>
          </div>
      </DialogContent>
      <DialogActions className='px-8 pb-6 pt-5 gap-3'>
        <GlobalButton action={onClose} variant={GlobalButtonVariant.secondaryButton}>
          Cancelar
        </GlobalButton>
        <GlobalButton action={onConfirm} variant={GlobalButtonVariant.primaryButton}>
          Confirmar y Aplicar
        </GlobalButton>
      </DialogActions>
    </Dialog>
  );
};

export default AmendmentConfirmModal;
